'use client';

import { ArrowRightIcon, BookOpenIcon, UserCircleIcon } from '@phosphor-icons/react';
import Link from 'next/link';

import {
  Badge,
  PRIMARY_ACTION_MOTION_CLASS,
  SECONDARY_ACTION_MOTION_CLASS,
} from '../../lib/header-constants';
import { cn } from '@/shared/utils/cn';
import { useNavbarContext } from './context';

const HeaderMobileActions = () => {
  const { accountUrl, classroomBadge, classroomUrl, hideLogin, loginUrl, onLogin, registerUrl, user } =
    useNavbarContext();

  if (user) {
    return (
      <div className="border-adipa-border space-y-1.5 border-t px-4 py-4">
        {classroomBadge ? (
          <div className="flex">
            <Badge color="magenta" label={classroomBadge} />
          </div>
        ) : null}
        <Link
          className={cn(
            'rounded-adipa-lg bg-adipa-primary text-adipa-primary-foreground flex min-h-11 w-full items-center justify-between px-4 text-sm font-semibold',
            PRIMARY_ACTION_MOTION_CLASS,
          )}
          href={classroomUrl}
        >
          <span className="flex items-center gap-2.5">
            <BookOpenIcon aria-hidden="true" size={18} weight="regular" />
            Ir a Mi aula
          </span>
          <ArrowRightIcon aria-hidden="true" size={16} weight="bold" />
        </Link>
        <Link
          className={cn(
            'rounded-adipa-lg border-adipa-border bg-adipa-surface text-adipa-text-secondary flex min-h-11 w-full items-center justify-between border px-4 text-sm font-semibold',
            SECONDARY_ACTION_MOTION_CLASS,
          )}
          href={accountUrl}
        >
          <span className="flex items-center gap-2.5">
            <UserCircleIcon aria-hidden="true" size={18} weight="regular" />
            Ver mi cuenta
          </span>
          <ArrowRightIcon aria-hidden="true" size={16} weight="bold" />
        </Link>
      </div>
    );
  }

  return (
    <div className="border-adipa-border space-y-2 border-t px-4 py-4">
      {!hideLogin && (
        <Link
          className={cn(
            'rounded-adipa-lg border-adipa-border bg-adipa-surface text-adipa-text-secondary inline-flex min-h-11 w-full items-center justify-center border px-4 text-sm font-semibold',
            SECONDARY_ACTION_MOTION_CLASS,
          )}
          href={loginUrl}
          onClick={onLogin}
        >
          Iniciar sesión
        </Link>
      )}
      <Link
        className={cn(
          'rounded-adipa-lg bg-adipa-primary text-adipa-primary-foreground inline-flex min-h-11 w-full items-center justify-center text-sm font-semibold',
          PRIMARY_ACTION_MOTION_CLASS,
        )}
        href={registerUrl}
      >
        Regístrate
      </Link>
    </div>
  );
};

export default HeaderMobileActions;
